import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../../environments/environment";

@Injectable({
  providedIn: 'root',
})
export class DevolucionDineroService {

  private apiUrl = environment.apiUrl;
  constructor(private http: HttpClient) {

  }


  RefundType(order_id: number, refund_type: string): Observable<{ status: boolean, message: string }> {
    return this.http.post<{ status: boolean, message: string }>(`${this.apiUrl}/refunds/type`, {
      order_id: order_id,
      refund_type: refund_type
    });
  }
}
